import(/* webpackMode: "eager" */ "/app/front_end/src/app/error.tsx");
